export default "__VITE_ASSET__CXRjX_E___"